exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ivu-upload-drag:hover{border:1px dashed #d9232e}.disabled,.disabled:hover{background:#e0e0e0;color:#eceaea}.loading{padding:5%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-167a6f05","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/fundraisers/components/show/EditProfile.vue
// module id = 253
// module chunks = 0